export default "/static/dashboard/build/app/img/v2/d823eed6ad2213018d1e1df79d70e7b7.png";